export default __webpack_public_path__ + "static/media/stone2.ff18c65e.png";